import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const PeakShaving: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 300h-134.92s0-30 0-30h104.92c16.57 0 30 13.43 30 30z' />
    <path d='m120 270h435v30h-435z' />
    <path d='m231.98 240 18.02-64.37 18.02 64.37h31.15l-34.73-124.04c-1.81-6.48-7.72-10.96-14.44-10.96s-12.63 4.48-14.44 10.96l-34.73 124.04z' />
    <path d='m348.79 583.8c6.62.53 12.8-3.35 15.19-9.54l59.85-154.7 61.91 188.58c1.93 5.88 7.27 9.97 13.45 10.3 6.19.33 11.92-3.16 14.47-8.8l54.49-120.45 59.23 170.81h31.75l-74.97-216.19c-2.01-5.8-7.36-9.79-13.49-10.07-6.12-.29-11.82 3.21-14.35 8.8l-54.11 119.6-62.97-191.83c-1.98-6.02-7.53-10.15-13.86-10.32-.13 0-.26 0-.39 0-6.18 0-11.75 3.8-13.99 9.59l-56.78 146.75-49.56-234.44-29.35 6.2 60 283.85c1.37 6.5 6.85 11.32 13.47 11.85z' />
    <path d='m151.28 660 73.43-370.37-29.42-5.84-74.59 376.21z' />
  </IconBase>
));

PeakShaving.displayName = 'PeakShaving';

export default PeakShaving;
